// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DebitCardV2DebitCardDetailDefaultResponse {
    static getAttributeTypeMap() {
        return DebitCardV2DebitCardDetailDefaultResponse.attributeTypeMap;
    }
}
DebitCardV2DebitCardDetailDefaultResponse.discriminator = undefined;
DebitCardV2DebitCardDetailDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DebitCardV2DebitCardDetailDefaultResponseData"
    }
];
//# sourceMappingURL=debitCardV2DebitCardDetailDefaultResponse.js.map